import { Company } from 'data/v1/data-contracts';
import { formatDate } from 'helpers/intl-helper';
import { formatPhoneNumber } from 'helpers/phone';
import { addressLinesForProject } from 'helpers/project-helper';

export type ProjectUser = {
  name: string;
};

type Context = {
  currentUser: { full_name: string };
  project: { name: string; title: string };
  projectUsers: ProjectUser[];
  contact?: { name: string; phone_number: string; email: string };
  company?: Company;
};

const projectPageTokens = {
  currentUserName: '{{currentUser.name}}',
  projectName: '{{project.name}}',
  projectAddress: '{{project.address}}',
  contactName: '{{contact.name}}',
  contactPhoneNumber: '{{contact.phoneNumber}}',
  contactEmail: '{{contact.email}}',
  projectUsers: '{{project.projectUsers}}',
  projectUsersCount: '{{project.projectUsersCount}}',
  dateToday: '{{date.today}}',
  companyName: '{{company.name}}',
  companyAddressLine1: '{{company.addressLine1}}',
  companyAddressLine2: '{{company.addressLine2}}',
  companyPhoneNumber: '{{company.phoneNumber}}',
};

const mixContentWithContext = (
  content: string,
  { currentUser, project, projectUsers, contact, company }: Context,
) => {
  const _contact = { name: '', phone_number: '', email: '', ...contact };
  const filteredProjectUsers = projectUsers.filter((u) => u.name);
  return (
    content
      // use new RegExp(pattern, 'g') with ProjectPageTokens
      .replace(
        new RegExp(`${projectPageTokens.dateToday}`, 'g'),
        formatDate(new Date()),
      )
      .replace(
        new RegExp(`${projectPageTokens.currentUserName}`, 'g'),
        currentUser.full_name || '',
      )
      .replace(
        new RegExp(`${projectPageTokens.projectName}`, 'g'),
        project.name,
      )
      .replace(
        new RegExp(`${projectPageTokens.contactName}`, 'g'),
        _contact.name,
      )
      .replace(
        new RegExp(`${projectPageTokens.projectAddress}`, 'g'),
        addressLinesForProject(project).join(' ') || '',
      )
      .replace(
        new RegExp(`${projectPageTokens.contactPhoneNumber}`, 'g'),
        _contact.phone_number,
      )
      .replace(
        new RegExp(`${projectPageTokens.contactEmail}`, 'g'),
        _contact.email,
      )
      .replace(
        new RegExp(`${projectPageTokens.projectUsers}`, 'g'),
        filteredProjectUsers.map((u) => u.name).join(', '),
      )
      .replace(
        new RegExp(`${projectPageTokens.projectUsersCount}`, 'g'),
        filteredProjectUsers?.length.toString() || '',
      )
      .replace(
        new RegExp(`${projectPageTokens.companyName}`, 'g'),
        company?.name || '',
      )
      .replace(
        new RegExp(`${projectPageTokens.companyAddressLine1}`, 'g'),
        company?.address_line_1 || 'Address Line 1',
      )
      .replace(
        new RegExp(`${projectPageTokens.companyAddressLine2}`, 'g'),
        company?.address_line_2 || 'Address Line 2',
      )
      .replace(
        new RegExp(`${projectPageTokens.companyPhoneNumber}`, 'g'),
        formatPhoneNumber(company?.phone_number) || 'Company Phone Number',
      )
  );
};

export default mixContentWithContext;
